import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { addNewExpenses, getAllExpenses } from "../../../apis/expences";
import { Moment } from "moment";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";

const Approve_loan = () => {
  const initialValues = {
    name: "",
    rate: "",
    address: "",
  };

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const { name, rate, address } = formData;
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  type EmployeeData = {
    key: number;
    Name: string;
    id: any;
    amount: number;
    currency: any;
    email: string;
    createdAt: string;
    Status: string;
  };
  const loginData = sessionStorage.getItem("info");
  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id: JSON.parse(loginData).user_id,
      };
      const response = await getAllExpenses(data);
      const employeeData = response?.data?.paymentData?.map(
        (item: any, i: number) => ({
          key: `${i + 1}`,
          Name: `${item.title}`,
          amount: item.amount || "Not Assigned",
          email: item.email || "Not Assigned",
          currency: item.currency || "Not Assigned",
          createdAt: item.createdAt || "Not Assigned",
          id: item.id,
        })
      );
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

    const exportToExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");
      XLSX.writeFile(workbook, "employee_data.xlsx");
    };

  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Search across every visible field.
  const filteredEmployeeData = React.useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return allEmployeeData;

    return allEmployeeData.filter((item) =>
      [item.Name, item.email, item.amount, item.currency, item.createdAt].some(
        (value) => String(value ?? "").toLowerCase().includes(query)
      )
    );
  }, [allEmployeeData, searchQuery]);

  const totalAmount = React.useMemo(
    () =>
      filteredEmployeeData.reduce((sum, item) => sum + (Number(item.amount) || 0), 0),
    [filteredEmployeeData]
  );

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.key}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.email}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.amount}</div>
            </p>
          </div>
        </div>
      ),
    },

    {
      title: "Currency",
      dataIndex: "currency",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record?.currency}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{formatDate(text)}</div>
          </p>
        </div>
      ),
    },
  ];

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let idData: any;
    if (loginData) {
      const response = JSON.parse(loginData);
      idData = response;
    }

    const payload = {
      status: "active",
      user_id: idData.user_id,
      user_type: idData.type,
      amount: formData.rate,
      title: formData.name,
      description: formData.address,
    };
    try {
      const response = await addNewExpenses(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2"></div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name, Email, Amount, Currency..."
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div style={{ margin: "0 1.5rem" }}>
                  <label style={{ color: "#000" }}>Total Amount</label>
                  <div
                    style={{
                      background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
                      color: "#fff",
                      borderRadius: "8px",
                      padding: "0.35rem 1rem",
                      marginTop: "5px",
                      fontWeight: 700,
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ₹ {totalAmount.toLocaleString("en-IN")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 3rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <div
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}

                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </div>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">

                      <li>
                        <div onClick={exportToExcel} className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {filteredEmployeeData && filteredEmployeeData.length > 0 && (
                <Table
                  dataSource={filteredEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Expenses</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Title <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="rate"
                            value={rate}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Description
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="textarea"
                            name="address"
                            value={address}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default Approve_loan;
